export default __webpack_public_path__ + "static/media/icon_rain_forest.4c242ad4.svg";